import { parsePhoneNumber } from 'libphonenumber-js/max';

import { PhoneNumber } from 'libphonenumber-js/types';

export const formatPhoneNumber = (_number: string | PhoneNumber): string => {
	const number = String(_number);

	try {
		const preparedNumber = number.charAt(0) === '+' ? number : `+${number}`;
		const phoneNumber = parsePhoneNumber(preparedNumber);

		return phoneNumber.formatInternational();
	} catch (_e) {
		return 'Invalid phone number';
	}
};
